import ListIcon from '@material-ui/icons/ListTwoTone';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
// import { useRecoilValue } from 'recoil';
import { useUrlToTitleElements } from '../../../api/products/catalogue';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import AppBreadcrumbs, { AppBreadcrumbsProps } from '../../../components/AppBreadcrumbs';
import StyledBreadcrumb from '../../../components/StyledBreadcrumb';
// import { localeState } from '../../../api/appState';

export interface ProductDetailPageBreadcrumbsProps extends Omit<AppBreadcrumbsProps, 'children'> {
  product: ProductDetailProduct;
}

const ProductDetailPageBreadcrumbs = React.forwardRef<HTMLDivElement, ProductDetailPageBreadcrumbsProps>(
  (props, ref) => (
    <React.Suspense fallback={<Skeleton variant='rect' width={'100%'} />}>
      <ProductDetailPageBreadcrumbsInner ref={ref} {...props} />
    </React.Suspense>
  ),
);

ProductDetailPageBreadcrumbs.displayName = 'ProductDetailPageBreadcrumbs';

export default ProductDetailPageBreadcrumbs;

const ProductDetailPageBreadcrumbsInner = React.forwardRef<HTMLDivElement, ProductDetailPageBreadcrumbsProps>(
  ({ product, ...rest }, ref) => {
    const reduced = (product.taxonomies || []).reduce(
      (acc, tx) => {
        if (!tx.startsWith('/catalogue')) return acc;
        const level = tx.split('/').length;
        return level >= acc.level ? { level, path: tx } : acc;
      },
      { level: 0, path: '' },
    );

    // const locale = useRecoilValue(localeState);
    const titleElements = useUrlToTitleElements(reduced.path);

    return (
      <AppBreadcrumbs disableHome ref={ref} {...rest}>
        {titleElements.map((item, idx) => (
          <StyledBreadcrumb
            key={idx.toString()}
            // to={`/${locale}${item.code}`}
            to={item.code}
            label={item.label}
            icon={item.code === '/catalogue' ? <ListIcon fontSize='small' /> : undefined}
          />
        ))}
      </AppBreadcrumbs>
    );
  },
);
